// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"fa5e838a","452":"80a6e76e"}[chunkId] + ".chunk.css";
};